// extracted by css-extract-rspack-plugin
export default {"cls1":"ConfirmationModal-cls1_te6","cls2":"ConfirmationModal-cls2_t2_ ConfirmationModal-cls1_te6"};